import axios from 'axios';
import { settings } from '@/plugins/settings';

export const securityCodeService = {

  myPin(): Promise<{pin: string | null; community_id: number | null; community_name: string | null}> {
    return axios({
      url: settings.endpoint + 'me/pin-code',
      method: 'GET',
      headers: { 'Cache-Control': 'no-cache' },
    }).then((response: any) => {
      const data = response.data && response.data.data ? response.data.data : response.data;
      return data || { pin: null, community_id: null, community_name: null };
    }).catch(() => ({ pin: null, community_id: null, community_name: null }));
  },

};
